export type RowClassFn<T> = (row: T) =>
  string |
  string[] |
  { [klass: string]: any; } |
  null |
  undefined;
